import { Badge } from '../components/ui/badge';
import { Card, CardContent } from '../components/ui/card';

const LOGOS = [
  { src: '/logo-axtel.png', alt: 'Axtel' },
  { src: '/logo-cemex.png', alt: 'Cemex' },
  { src: '/logo-izzi.png', alt: 'Izzi' },
  { src: '/logo-mcm.webp', alt: 'MCM' },
  { src: '/logo-telmex.png', alt: 'Telmex' },
  { src: '/logo-totalplay.png', alt: 'Totalplay' },
];

const SECTORS = [
  { title: 'Operadores y Carriers', description: 'Prestadores de servicios de voz, SIP Trunking y comunicaciones empresariales.' },
  { title: 'ISPs y Cable Operadores', description: 'Proveedores de internet, telefonía y servicios convergentes.' },
  { title: 'Integradores de Tecnología', description: 'Socios especializados en infraestructura y comunicaciones unificadas.' },
  { title: 'Empresas y Corporativos', description: 'Organizaciones que requieren soluciones de voz, Microsoft Teams y Contact Center.' },
  { title: 'Gobierno e Instituciones Públicas', description: 'Proyectos de comunicaciones y colaboración para entidades federales y estatales.' },
];

export default function Clients() {
  return (
    <div className="py-16 md:py-20" data-testid="clients-page">
      <div className="mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mb-12">
          <Badge variant="secondary" className="mb-4">Clientes</Badge>
          <h1 className="text-4xl sm:text-5xl font-display font-semibold tracking-tight mb-4" data-testid="clients-page-title">
            EMPRESAS QUE CONFÍAN EN NOSOTROS
          </h1>
          <p className="text-base md:text-lg text-muted-foreground leading-relaxed" data-testid="clients-subtitle">
            Más de una década apoyando a operadores, carriers, ISPs, integradores y empresas en la implementación de soluciones de comunicaciones críticas.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 mb-16" data-testid="clients-logos-grid">
          {LOGOS.map(logo => (
            <Card key={logo.alt} className="hover:shadow-md transition-shadow duration-300">
              <CardContent className="p-6 flex items-center justify-center h-28">
                <img
                  src={logo.src}
                  alt={logo.alt}
                  className="h-12 w-auto object-contain"
                  data-testid={`clients-logo-${logo.alt.toLowerCase()}`}
                />
              </CardContent>
            </Card>
          ))}
        </div>

        <h2 className="text-xl md:text-2xl font-display font-semibold mb-6" data-testid="clients-sectors-title">
          SECTORES QUE ATENDEMOS
        </h2>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="clients-sectors-grid">
          {SECTORS.map(s => (
            <Card key={s.title} data-testid={`clients-sector-${s.title.toLowerCase().replace(/\s+/g, '-')}`}>
              <CardContent className="p-5 space-y-2">
                <p className="font-display font-semibold text-base">{s.title}</p>
                <p className="text-sm text-muted-foreground leading-relaxed">{s.description}</p>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </div>
  );
}
